<template>
  <div ref="root" class="mx-auto w-full max-w-5xl px-4">
    <p class="font-mono text-sm text-[var(--accent)]">{{ t('experience.title') }}</p>
    <h2 class="mt-1 text-2xl font-bold">{{ t('experience.heading') }}</h2>
    <p class="mt-1 font-mono text-xs text-[var(--muted)]">{{ t('experience.present') }}</p>
    <div class="mt-5 space-y-4">
      <ExperienceTimeline v-for="entry in experience" :key="entry.company" :entry="entry" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { experience } from '../data'
import ExperienceTimeline from '../components/ExperienceTimeline.vue'
import { useReveal } from '../composables/useMotion'

const { t } = useI18n()
const root = ref<HTMLElement | null>(null)
useReveal(root)
</script>
